'use client'

import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { useI18n } from '@dustin-web/microsite-components/src/i18n'

type Props = {
  rentalPrice: number
  numberOfMonths?: number | null
}

export const ProductPriceCurrency = ({ rentalPrice, numberOfMonths }: Props) => {
  const { translate } = useTranslations()
  const { formatCurrency } = useI18n()
  return (
    <div className="u-pt-16">
      <span className="u-fs-14 u-color-mute">
        {translate('Product_PayPerMonth_Description', {
          amount: formatCurrency(rentalPrice),
          months: numberOfMonths || 36,
        })}
      </span>
    </div>
  )
}
